var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThawAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 19.5C14.5 20.8807 13.3807 22 12 22C10.6193 22 9.5 20.8807 9.5 19.5C9.5 18.1193 12 15 12 15C12 15 14.5 18.1193 14.5 19.5Z",
    stroke: "#1FABE8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V5.18934L9.53034 3.46967C9.23744 3.17678 8.76257 3.17678 8.46968 3.46967C8.17678 3.76256 8.17678 4.23744 8.46968 4.53033L11.25 7.31066V8.32501C9.78066 8.62327 8.62328 9.78065 8.32501 11.25H7.31066L4.53033 8.46967C4.23744 8.17678 3.76256 8.17678 3.46967 8.46967C3.17678 8.76256 3.17678 9.23744 3.46967 9.53033L5.18934 11.25H2C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H5.18934L3.46967 14.4697C3.17678 14.7626 3.17678 15.2374 3.46967 15.5303C3.76256 15.8232 4.23744 15.8232 4.53033 15.5303L7.31066 12.75H8.32501C8.47671 13.4973 8.85063 14.1639 9.3748 14.6778L10.2336 13.3938C9.93075 13.0105 9.75 12.5264 9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 12.5264 14.0692 13.0105 13.7664 13.3938L14.6252 14.6778C15.1494 14.1639 15.5233 13.4973 15.675 12.75H16.6893L19.4697 15.5303C19.7626 15.8232 20.2374 15.8232 20.5303 15.5303C20.8232 15.2374 20.8232 14.7626 20.5303 14.4697L18.8107 12.75H22C22.4142 12.75 22.75 12.4142 22.75 12C22.75 11.5858 22.4142 11.25 22 11.25H18.8107L20.5303 9.53033C20.8232 9.23744 20.8232 8.76256 20.5303 8.46967C20.2374 8.17678 19.7626 8.17678 19.4697 8.46967L16.6893 11.25H15.675C15.3767 9.78065 14.2194 8.62328 12.75 8.32502V7.31066L15.5303 4.53034C15.8232 4.23744 15.8232 3.76257 15.5303 3.46968C15.2374 3.17678 14.7626 3.17678 14.4697 3.46968L12.75 5.18934V2Z",
    fill: "#1FABE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThawAsset);
export default __webpack_public_path__ + "static/media/thaw-asset.8cdcd281c538f2e4640dbf06ff119d5d.svg";
export { ForwardRef as ReactComponent };